import { Injectable } from "@angular/core";
import { Observable, EMPTY } from "rxjs";
import { RequestUtilsService } from "./requestUtils";
import { GetHttpHeaders, GetHttpHeadersSimple } from "./serviceUtils";
import { mapCases } from "./requestMapperUtils";
import type { Case } from "../interfaces/case.interface";

@Injectable({
    providedIn: "root"
})
export class CaseService {
    constructor(private requestUtils: RequestUtilsService) {}

    getCases(accountId: string): Observable<Case[]> {
        if (!accountId) return EMPTY;
        const url = `incidents?$select=title,ticketnumber,createdon,incidentid,description,svk_solution,statuscode,statecode,_svk_businessarea_value,_svk_account_value,_svk_reportedby_value,svk_showonweb,svk_duedate&$filter=(_svk_casecategory_value ne ef52b58d-6bb0-ee11-a569-000d3a4ad69e and svk_showonweb eq true and _customerid_value eq ${accountId} and (statecode eq 0 or statecode eq 1 or Microsoft.Dynamics.CRM.LastXDays(PropertyName='svk_dateofcompletion',PropertyValue=500)))&$orderby=createdon desc`;
        return this.requestUtils.createGetRequest<Case[]>(url, mapCases, GetHttpHeadersSimple);
    }

    getCase(accountId: string, incidentId: string): Observable<Case[]> {
        if (!accountId) return EMPTY;
        const url = `incidents?$select=title,ticketnumber,createdon,incidentid,description,svk_solution,statuscode,statecode,_svk_businessarea_value,_svk_account_value,_svk_reportedby_value,svk_showonweb,svk_duedate&$filter=(_svk_casecategory_value ne ef52b58d-6bb0-ee11-a569-000d3a4ad69e and svk_showonweb eq true and _customerid_value eq ${accountId} and incidentid eq ${incidentId} and (statecode eq 0 or statecode eq 1 or Microsoft.Dynamics.CRM.LastXDays(PropertyName='svk_dateofcompletion',PropertyValue=500)))&$orderby=createdon desc`;
        return this.requestUtils.createGetRequest<Case[]>(url, mapCases, GetHttpHeadersSimple);
    }

    updateCase(caseId: string, body: any): Observable<any> {
        if (!caseId) return EMPTY;
        const url = `incidents(${caseId})`;
        return this.requestUtils.createPatchRequest<any>(url, body, (response) => response, GetHttpHeadersSimple);
    }

    getCaseReporter(contactId: string | null): Observable<any> {
        if (!contactId) return EMPTY;
        const url = `contacts?$select=contactid,fullname&$filter=(contactid eq '${contactId}')`;
        return this.requestUtils.createGetRequest<any>(url, (response) => response, GetHttpHeaders);
    }

    closeCaseCustomer(incidentId: string): Observable<any> {
        if (!incidentId) return EMPTY;
        const url = `incidents(${incidentId})`;
        const body = { statecode: 2 };
        return this.requestUtils.createPatchRequest<any>(url, body, (response) => response, GetHttpHeadersSimple);
    }
}
